import React, { useState, useEffect } from "react";
import Globals from "../../Globals";
import { Link } from "react-router-dom";

const API = Globals.API;

export default function OmraB2B() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedEvent, setSelectedEvent] = useState(null);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const res = await fetch(`${API}/events`);
      const data = await res.json();
      if (data.success) {
        const filtered = data.data.filter(
          (e) => e.category === "omra" && e.isActive
        );
        setEvents(filtered);
      }
    } catch (err) {
      console.error("Error fetching events:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        fontFamily: "Inter, sans-serif",
        padding: "40px 5%",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "40px",
        }}
      >
        <h1
          style={{
            fontSize: "32px",
            fontWeight: "700",
            color: "#1e3a8a",
          }}
        >
          🌍 Gestion OMRA
        </h1>
        <Link to='/b2b'
          style={{
            background: "linear-gradient(135deg, #3b82f6, #1e40af)",
            color: "white",
            padding: "12px 20px",
            border: "none",
            borderRadius: "10px",
            fontWeight: 600,
            cursor: "pointer",
            boxShadow: "0 4px 12px rgba(30,58,138,0.3)",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => (e.target.style.opacity = "0.9")}
          onMouseLeave={(e) => (e.target.style.opacity = "1")}
        >
         ≪
        </Link>
      </div>

      {/* Loading */}
      {loading ? (
        <div
          style={{
            textAlign: "center",
            padding: "80px 0",
            color: "#64748b",
          }}
        >
          <i className="fa fa-spinner fa-spin fa-2x mb-3"></i>
          <p>Chargement des voyages...</p>
        </div>
      ) : events.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            padding: "100px 0",
            color: "#94a3b8",
          }}
        >
          <i className="fa fa-folder-open fa-3x mb-3"></i>
          <p>Aucun voyage disponible pour le moment.</p>
        </div>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "25px",
          }}
        >
          {events.map((event) => (
            <div
              key={event._id}
              style={{
                background: "white",
                borderRadius: "16px",
                boxShadow: "0 6px 20px rgba(0,0,0,0.05)",
                overflow: "hidden",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-6px)";
                e.currentTarget.style.boxShadow =
                  "0 10px 25px rgba(0,0,0,0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                  "0 6px 20px rgba(0,0,0,0.05)";
              }}
              onClick={() => setSelectedEvent(event)}
            >
              <div style={{ position: "relative" }}>
                <img
                  src={event.image}
                  alt={event.title}
                  style={{
                    width: "100%",
                    height: "180px",
                    objectFit: "cover",
                  }}
                />
                <span
                  style={{
                    position: "absolute",
                    top: "10px",
                    left: "10px",
                    background: "rgba(59,130,246,0.9)",
                    color: "white",
                    fontSize: "14px",
                    padding: "4px 10px",
                    borderRadius: "6px",
                  }}
                >
                  {event.destination}
                </span>
              </div>

              <div style={{ padding: "20px" }}>
                <h3
                  style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "#1e3a8a",
                    marginBottom: "10px",
                  }}
                >
                  {event.title}
                </h3>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#475569",
                    marginBottom: "15px",
                    minHeight: "45px",
                  }}
                >
                  {event.description.slice(0, 90)}...
                </p>

                <div
                  style={{
                    background: "#f1f5f9",
                    borderRadius: "10px",
                    padding: "10px 15px",
                    marginBottom: "15px",
                  }}
                >
                  <small style={{ color: "#475569" }}>
                    Prix :{" "}
                    <span
                      style={{ fontWeight: "700", color: "#1e3a8a" }}
                    >
                      {event.price?.toFixed(2)} TND
                    </span>
                  </small>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      backgroundColor: "#dcfce7",
                      color: "#15803d",
                      padding: "4px 10px",
                      borderRadius: "6px",
                      fontSize: "13px",
                    }}
                  >
                    {event.includedServices?.length || 0} services inclus
                  </span>
                  <button
                    style={{
                      border: "none",
                      background: "none",
                      color: "#3b82f6",
                      fontWeight: "600",
                      cursor: "pointer",
                    }}
                  >
                    Voir détails →
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal */}
      {selectedEvent && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={() => setSelectedEvent(null)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "white",
              borderRadius: "16px",
              maxWidth: "700px",
              width: "90%",
              padding: "30px",
              boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
              overflowY: "auto",
              maxHeight: "90vh",
            }}
          >
            <h2 style={{ color: "#1e3a8a", marginBottom: "20px" }}>
              {selectedEvent.title}
            </h2>
            <img
              src={selectedEvent.image}
              alt={selectedEvent.title}
              style={{
                width: "100%",
                borderRadius: "10px",
                marginBottom: "20px",
                maxHeight: "300px",
                objectFit: "cover",
              }}
            />
            <p style={{ color: "#475569", lineHeight: "1.6" }}>
              {selectedEvent.description}
            </p>
            <hr />
            <p>
              <strong>Destination :</strong> {selectedEvent.destination}
            </p>
            <p>
              <strong>Prix :</strong> {selectedEvent.price?.toFixed(2)} TND
            </p>
            <button
              onClick={() => setSelectedEvent(null)}
              style={{
                marginTop: "20px",
                padding: "10px 20px",
                background: "#1e3a8a",
                color: "white",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              Fermer
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
